import config from '@/config'
import axios from 'axios'
import { authHeader } from '@/helpers'
import { acoToAES, aesToAco } from '@/helpers/acoData'

const { API_URL } = config

export const setupService = {
  setBilling,
  getStripeToken
}

async function setBilling(payload) {
  let { billingAddress, token } = payload
  let url = `${API_URL}/api/user/billing/set`
  let data = { billingAddress, token }
  let opts = {
    url,
    data,
    method: 'POST',
    headers: authHeader()
  }
  let resp = await axios(opts)
  return resp.data

}
async function getStripeToken(card) {
  let encrypted = acoToAES(card)
  let opts = {
    method: 'POST',
    url: `${API_URL}/api/user/billing/genToken`,
    data: {
      encrypted
    },
    headers: authHeader()
  }
  let res = await axios(opts)
  return res.data
}